import { Row, Col, Checkbox, Form } from 'antd';
import { criiptoAuthMethodsByCountry } from '../../utils/consts';
import { useEffect, useState } from 'react';

const defaultStateCriiptoMethods = {
    se: [],
    no: [],
    fi: [],
    dk: [],
};

export const CriiptoMethods = ({
    handleCriiptoMethods,
    errors,
    methods,
    editMode,
}) => {
    const [criiptoMethods, setCriiptoMethods] = useState(
        methods || defaultStateCriiptoMethods,
    );

    useEffect(() => {
        handleCriiptoMethods(criiptoMethods);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [criiptoMethods]);

    const handleCriiptoMethod = (countryCode, method) => {
        setCriiptoMethods((prevState) => {
            const existingMethods = prevState[countryCode];
            const methodExists = existingMethods.includes(method);

            let updatedMethods;

            if (methodExists) {
                updatedMethods = existingMethods.filter((m) => m !== method);
            } else {
                updatedMethods = [...existingMethods, method];
            }

            return {
                ...prevState,
                [countryCode]: updatedMethods,
            };
        });
    };

    return (
        <Form.Item
            validateStatus={errors?.criipto_methods ? 'error' : ''}
            help={errors?.criipto_methods}
            style={{ margin: 0 }}
        >
            {criiptoAuthMethodsByCountry?.map(
                ({ countryCode, methods, countryLabel }) => (
                    <Row
                        key={countryCode}
                        className={`${
                            editMode
                                ? 'details-table__row details-table__cell'
                                : ''
                        }`}
                        style={{ marginBottom: '8px' }}
                    >
                        <Col
                            span={editMode ? 7 : 4}
                            style={editMode ? { marginRight: '10px' } : ''}
                        >
                            <h3 className="input-label">{countryLabel}</h3>
                        </Col>
                        {methods?.map(({ value, label }, index) => (
                            <Col
                                key={value}
                                span={
                                    editMode
                                        ? index > 0
                                            ? 5
                                            : 4
                                        : index > 0
                                        ? 7
                                        : 6
                                }
                            >
                                <Checkbox
                                    onChange={() =>
                                        handleCriiptoMethod(countryCode, value)
                                    }
                                    checked={criiptoMethods[
                                        countryCode
                                    ].includes(value)}
                                >
                                    {label}
                                </Checkbox>
                            </Col>
                        ))}
                    </Row>
                ),
            )}
        </Form.Item>
    );
};
